import React from 'react'
import {DonateButton} from 'fepp'
import {TaxNotice} from 'shared'

export const DonateButtonCombo = ({fundraisingEvent, gaAction, labelClosed}) => {
  return <div style={{maxWidth: '300px', margin: '0 auto'}}>
    {fundraisingEvent.donations_prohibited || <DonateButton className='btn-huge btn-block' fundraisingEvent={fundraisingEvent} gaAction={gaAction} />}
    {fundraisingEvent.donations_prohibited || <TaxNotice additionalClassName="generic-tax-deductibility-hint" />}
    {labelClosed && fundraisingEvent.closed_at && <span className="badge badge-closed">{I18n.t('misc.state_label_closed')}</span>}
  </div>
}
